import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  page: {
    maxWidth: 1470,
    minWidth: 1095,
    margin: "100px 0px 60px",
    paddingRight: 45,
    paddingLeft: 245,
  },
});

export default useStyles;
